export default "__VITE_ASSET__Dwgv4SyA__"